"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.ButtonVariants = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const isFunction_1 = __importDefault(require("lodash/isFunction"));
const ThemeProvider_1 = require("../../utils/ThemeProvider");
const Spinner_1 = require("../Spinner/Spinner");
const Utils_1 = require("../../utils/Utils");
const StyleUtils_1 = require("../../utils/StyleUtils");
const Button_styles_1 = require("./styles/Button.styles");
const __DEV__ = process.env.NODE_ENV !== 'production';
var ButtonVariants;
(function (ButtonVariants) {
    ButtonVariants["DEFAULT"] = "default";
    ButtonVariants["SMALL"] = "small";
    ButtonVariants["GHOST"] = "ghost";
})(ButtonVariants = exports.ButtonVariants || (exports.ButtonVariants = {}));
const swallowEvents = e => {
    e.preventDefault();
    e.stopPropagation();
    if ((0, isFunction_1.default)(e.stopImmediatePropagation)) {
        e.stopImmediatePropagation();
    }
    return false;
};
const Button = (props) => {
    const { children, className = '', disabled = false, fullWidth = false, isBusy = false, onBlur, onClick, onFocus, onMouseEnter, onMouseLeave, tabIndex = 0, type = 'button', variant = ButtonVariants.DEFAULT, id, testId, accessibilityLabel } = props, buttonProps = __rest(props, ["children", "className", "disabled", "fullWidth", "isBusy", "onBlur", "onClick", "onFocus", "onMouseEnter", "onMouseLeave", "tabIndex", "type", "variant", "id", "testId", "accessibilityLabel"]);
    const theme = (0, ThemeProvider_1.useTheme)();
    if (!theme) {
        if (__DEV__) {
            console.error('`Button` component must be a child of a `ThemeProvider`');
        }
        return null;
    }
    const overrideOnClick = disabled || isBusy ? swallowEvents : onClick;
    const styles = (0, Button_styles_1.getButtonStyles)();
    const dtiList = (0, Utils_1.getTestIdAttribute)(testId);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ id: id, "aria-disabled": disabled, "aria-busy": isBusy, "aria-label": accessibilityLabel, className: (0, StyleUtils_1.classNames)('Button-local', styles.wrapper, fullWidth && styles.fullWidth, className) }, dtiList, { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ type: type, className: `${styles.button} ${styles[variant]} ${fullWidth ? styles.fullWidth : ''}`, disabled: disabled, "aria-busy": isBusy, "aria-disabled": disabled, tabIndex: tabIndex, onClick: overrideOnClick, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, buttonProps, { children: children })), isBusy && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: styles.busy }, { children: (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { color: theme.colors.$content100 }) })))] })));
};
exports.Button = Button;
